import React from 'react';
import { locales } from '../../translations/locales';
import { ModuleRP } from '../ModRP';


const ModalNewGame = (props) => {
    const { locale } = props;

    return (
        <div
            className="modal"
            id="modalRp"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
            aria-labelledby="modalTitle"
            aria-hidden="true"
        >
            <div className='modal-dialog modal-dialog-scrollable modal-dialog-centered'>
                <div className='modal-content'>
                    <div className='modal-header'>
                        <h5 className='modal-title' id='modalRpTitle'>
                            {locales[locale].modals.newGame.title}
                        </h5>
                        <button type='button' className='close' data-dismiss='modal' aria-label='Close' id='modalRpClose'>
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                    <div className='modal-body text-center' id='modalRp-body'>
                        <form onSubmit={(event) => {
                            event.preventDefault();
                            ModuleRP.createNewGame();
                        }}>
                            <input type="text" id="gameName" className="" name="gameName"
                                placeholder={locales[locale].modals.newGame.gameName}
                                autoComplete='false'
                            />
                        </form>
                        <div id="informations"></div>
                    </div>
                    <div className='modal-footer' id='modalRp-footer'>
                        <button className='btn btn-success' id='btn-createNewGame' onClick={() => ModuleRP.createNewGame()}>
                            {locales[locale].create}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalNewGame;
